import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import { X, ExternalLink } from "lucide-react";

const icon = L.divIcon({
  className: "",
  html: `<div style="width:22px;height:22px;border-radius:50%;background:#E6B34A;border:3px solid #0A1030;box-shadow:0 0 0 2px #E6B34A"></div>`,
  iconSize: [22, 22],
  iconAnchor: [11, 11],
});

// Modal showing a Leaflet pin for an event's location + a directions link.
export default function EventMapModal({ ev, onClose }) {
  const loc = [ev.venue, ev.city, ev.country].filter(Boolean).join(", ");
  const gmaps = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(loc)}`;
  const hasCoords = typeof ev.lat === "number" && typeof ev.lng === "number";
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" data-testid="event-map-modal" onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} className="w-full max-w-lg rounded-3xl border border-white/10 bg-[#141C42] overflow-hidden">
        <div className="flex items-center justify-between px-5 py-4">
          <div className="min-w-0">
            <h3 className="font-display font-bold text-lg truncate">{ev.title}</h3>
            <p className="text-xs text-zinc-400 truncate">{loc}</p>
          </div>
          <button onClick={onClose} className="text-zinc-500 hover:text-white shrink-0"><X className="w-5 h-5" /></button>
        </div>
        {hasCoords ? (
          <MapContainer center={[ev.lat, ev.lng]} zoom={12} style={{ height: 300, width: "100%" }} scrollWheelZoom={false}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="&copy; OpenStreetMap contributors" className="map-tiles-dark" />
            <Marker position={[ev.lat, ev.lng]} icon={icon}><Popup>{ev.venue || ev.city}</Popup></Marker>
          </MapContainer>
        ) : (
          <div className="h-40 flex items-center justify-center text-sm text-zinc-500">Location map unavailable.</div>
        )}
        <div className="p-5">
          <a href={gmaps} target="_blank" rel="noreferrer" data-testid="event-directions" className="w-full inline-flex items-center justify-center gap-2 px-4 py-3 rounded-xl bg-[#E6B34A] text-[#0A1030] font-bold hover:bg-[#CF9A34] transition-colors">
            <ExternalLink className="w-4 h-4" /> Get directions
          </a>
        </div>
      </div>
    </div>
  );
}
